@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;

  .preview {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 6px;
  }

  .actions {
    &.skeletonsContainer {
      display: flex;
      flex-direction: column;
      gap: 28px;
      padding: 0 60px;

      @include for-phone-only {
        padding: 0;
        gap: 20px;
      }
    }
  }
}

.postButtons {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.integration {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 20px;
  gap: 8px;

  .avatar {
    height: 20px;
    width: 20px;
  }

  .displayName {
    @include md-sohne;
  }
}
